/** `/courses` → `null`; `/courses/M02` → `'M02'`. Anything not a lesson code → `null`. */
export function parseCoursePath(path: string): string | null {
  const match = /^\/courses\/([A-Z]\d{2})\/?$/.exec(path)
  return match?.[1] ?? null
}

export function coursePath(code: string): string {
  return `/courses/${code}`
}
